import { z } from 'zod';

import pgIntervalSchema from 'validationSchemas/pgInterval';

export const FormSchema = z.object({
  performance_time_required: pgIntervalSchema.nullable(),
  observation_time_required: pgIntervalSchema.nullable(),
});

export type FormInputValues = z.input<typeof FormSchema>;
export type FormOutputValues = z.output<typeof FormSchema>;
